import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { Button } from '@/components/ui/button';

const EXTRA_ROUTE_ROLES = {
  '/dashboard/super-admin': ['SUPER_ADMIN'],
  '/dashboard/treasurer': ['TREASURER', 'ADMIN'],
  '/dashboard/secretary': ['SECRETARY', 'ADMIN'],
  '/dashboard/create-users': ['ADMIN', 'SECRETARY'],
  '/dashboard/student-parent': ['ADMIN', 'SECRETARY'],
  '/dashboard/billing': ['ADMIN', 'ACCOUNTANT', 'PRINCIPAL', 'TREASURER', 'SECRETARY', 'PARENT'],
};

export const RouteRoleGuard = ({ navigation, role, children }) => {
  const { pathname } = useLocation();
  if (role === 'SUPER_ADMIN') return children;
  const base = pathname.split('/').slice(0, 3).join('/');
  const roles = EXTRA_ROUTE_ROLES[base] || navigation.find((n) => n.href === base && n.roles)?.roles;
  if (!roles || roles.includes(role)) return children;
  return (
    <div className="p-10 text-center max-w-md mx-auto" data-testid="access-denied">
      <ShieldOff className="w-14 h-14 mx-auto text-gray-400 mb-4" />
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Accès refusé</h2>
      <p className="text-gray-600 mb-6">Cette page n’est pas disponible pour votre profil.</p>
      <Link to="/dashboard"><Button data-testid="access-denied-home-btn">Retour au tableau de bord</Button></Link>
    </div>
  );
};

export default RouteRoleGuard;
